import React from 'react';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';

import { getDateValue } from '../../utils/date';

class BlueBookViewForm extends React.Component {

    // static PropTypes = {
    //     blueBook: PropTypes.object.isRequired,
    //     contracts: PropTypes.array.isRequired,
    // }

    render() {
        const { blueBook } = this.props;
        return (
            <div className="modal-form blue-book-form">

                <div>
                    <div className="row">

                        {blueBook.dateVisit
                            ? <div className="col l2 m4 s12">
                                <div className="control required">
                                    <label>Date of Visit</label>
                                    <span>{getDateValue(blueBook.dateVisit)}</span>
                                </div>
                            </div>
                            : null}

                        {blueBook.dayOfWeek
                            ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>Day of Week</label>
                                    <span> {blueBook.dayOfWeek}  </span>
                                </div>
                            </div>
                            : null}

                        {blueBook.contractRegNo
                            ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>Registration</label>
                                    <span> {blueBook.contractRegNo}  </span>
                                </div>
                            </div>
                            : null}

                        {blueBook.ccd
                            ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>CCD #</label>
                                    <span> {blueBook.ccd} </span>
                                </div>
                            </div>
                            : null}

                        {blueBook.totalCCD
                            ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>Of</label>
                                    <span> {blueBook.totalCCD} </span>
                                </div>
                            </div>
                            : null}

                        {blueBook.weather
                            ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>Weather</label>
                                    <span>{blueBook.weather} </span>
                                </div>
                            </div>
                            : null}
                    </div>

                    <div className="row">
                        {blueBook.tempAM
                           ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>Temp: AM</label>
                                    <span>{blueBook.tempAM}</span>
                                </div>
                            </div>
                            : null}

                        {blueBook.tempPM
                            ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>Temp: PM</label>
                                    <span>{blueBook.tempPM}</span>
                                </div>
                            </div>
                            : null}

                        {blueBook.siteCondition
                            ? <div className="col l2 m4 s12">
                                <div className="control">
                                    <label>Site Condition</label>
                                    <span>{blueBook.siteCondition}</span>
                                </div>
                            </div>
                            : null}

                    </div>
                </div>

                {this.props.blueBook.blueBookTrades.length > 0
                    ? <div className="blue-book margin-top-1">
                        <div className="table-wrap" id="hiddenXscroll">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Prime Trade</th>
                                        <th>Sub Trade</th>
                                        <th>Actual # of Workers *</th>
                                        <th>Hours *</th>
                                        <th>Special Equipment</th>
                                        <th>Location and Description of Work in progress *</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.blueBook.blueBookTrades.map((childRow, index) =>

                                            <tr key={index}>
                                                <td> {childRow.primeTrade} </td>
                                                <td> {childRow.subTrade} </td>
                                                <td>{childRow.noWorkers} </td>
                                                <td>
                                                    {childRow.hours}
                                                </td>
                                                <td>{childRow.specialEquipment}</td>
                                                <td>{childRow.locDescWorkInProgress} </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : null}

                {blueBook.comments.length > 0
                    ? <div className="row">
                        <div className="control">
                            <label>General remarks: Reasons for delay, special instructions, tests, shut downs, notable incidents, materials delivered to site</label>
                            <span>{blueBook.comments}</span>
                        </div>
                    </div>
                    : null}

                <div className="row">

                    {blueBook.notAtSite
                        ? <div className="col l2">
                            <label></label>
                            <span>Not at site</span>
                        </div>
                        : null}

                    {!blueBook.notAtSite  && blueBook.cpmTimeIn
                       ? <div className="col l2">
                            <div className="control">
                                <label>CPM Time in</label>
                                <span>{blueBook.cpmTimeIn}</span>
                            </div>
                        </div>
                        : null }

                    {!blueBook.notAtSite && blueBook.cpmTimeOut
                        ? <div className="col l2 ">
                            <div className="control">
                                <label>CPM Time out</label>
                                <span>{blueBook.cpmTimeOut}</span>
                            </div>
                        </div>
                        : null}

                </div>

            </div>
        );
    }
}

BlueBookViewForm.propTypes = {
    blueBook: PropTypes.object.isRequired,
    contracts: PropTypes.array.isRequired
};

export default BlueBookViewForm;